let baseUrl=process.env.NODE_ENV==='development'?'/proxy':'//vueshop.glbuys.com';
export default {
    baseUrl:baseUrl,
    token:"1ec949a15fb709370f",
    path:"/"
}
